import React from 'react'

export type CopyIconProps = {
  color?: string
  className?: string
  width?: number
  height?: number
}

export const CopyIcon = ({
  color = 'currentColor',
  className,
  width = 16,
  height = 16,
}: CopyIconProps) => (
  <svg
    aria-label='Copy'
    className={className}
    fill='none'
    height={height}
    role='img'
    viewBox='0 0 24 24'
    width={width}
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      height='13'
      rx='2'
      ry='2'
      stroke={color}
      strokeWidth='2'
      width='13'
      x='9'
      y='9'
    />
    <path
      d='M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1'
      stroke={color}
      strokeWidth='2'
    />
  </svg>
)
